import * as React from 'react';
import * as PropTypes from 'prop-types';
import { classNames } from '@progress/kendo-react-common';
import { validatePackage } from '@progress/kendo-licensing';
import { packageMetadata } from './package-metadata';
/**
 * Represents the KendoReact Error component.
 * Render the error text that will be shown underneath the form editor after a validation.
 */

export var Error = function Error(props) {
  validatePackage(packageMetadata);
  var errorClassName = classNames({
    'k-form-error': true,
    'k-text-start': props.direction === 'start',
    'k-text-end': props.direction === 'end'
  }, props.className);
  return React.createElement("div", {
    id: props.id,
    role: 'alert',
    style: props.style,
    className: errorClassName
  }, props.children);
};
Error.propTypes = {
  id: PropTypes.string,
  direction: PropTypes.oneOf(['start', 'end']),
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.node]),
  style: PropTypes.object,
  className: PropTypes.string
};
Error.defaultProps = {
  direction: 'start'
};
Error.displayName = 'KendoReactError';